import { useRef } from "react";

export const TiltCard = ({ children, className = "", ...rest }) => {
  const ref = useRef();
  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    ref.current.style.transform = `rotateX(${-y * 14}deg) rotateY(${x * 14}deg) translateZ(12px)`;
  };
  const onLeave = () => { ref.current.style.transform = "rotateX(0deg) rotateY(0deg) translateZ(0px)"; };
  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={onLeave} {...rest}
      className={`${className} [transform-style:preserve-3d] transition-transform duration-200 ease-out will-change-transform`}>
      {children}
    </div>
  );
};
